import React from "react";
import headerBg from "./assets/picOne.png";

const ServiceCharter = () => {
  const services = [
    {
      sn: 1,
      service: "Development of a new Malawi Standard",
      requirements:
        "Submit a request to the MBS for the development of a standard",
      // charges:
      //   "No cost (normal process) / Fast track: cost determined after request",
      delivery: "Within 12 months",
      // justification:
      //   "From experience, it takes on average 12 months to develop a Malawi Standard.",
    },
    {
      sn: 2,
      service: "Review a Malawi Standard",
      requirements:
        "Submit a request to the MBS for the review of a standard",
      // charges:
      //   "No cost (normal process) / Fast track: cost determined after request",
      delivery: "Within 12 months",
      // justification:
      //   "Same justification as development - typical 12-month cycle.",
    },
    {
      sn: 3,
      service: "Acknowledge your correspondence on TBT/SPS inquiries",
      requirements: "Submission of a TBT/SPS inquiry to the MBS",
      // charges: "Free",
      delivery: "Within 24 hours",
      // justification: "N/A",
    },
    {
      sn: 4,
      service:
        "Respond to your correspondence on TBT/SPS inquiries if a detailed reply is required that may take additional time to research within",
      requirements: "Submission of a TBT/SPS inquiry to the MBS",
      // charges: "Free",
      delivery: "Within 10 working days",
      // justification: "N/A",
    },
    {
      sn: 5,
      service: "Respond to general correspondence to the MBS",
      requirements: "Submission of a correspondence to the MBS",
      // charges: "Free",
      delivery: "Within 5 working days",
      // justification:
      //   "General criterion set to ensure timeliness in responding to client correspondences.",
    },
    {
      sn: 6,
      service: "Import certification",
      requirements:
        "Imports commercial invoice; product test certificate from manufacturer; certificate of conformance from recognized certification body e.g NSB; consignment packing list; material safety data of product",
      // charges:
      //   "IQMS fees: 0.65% of FOB value (MK25,000-MK500,000) + admin + test charges + VAT; Cess: 0.5% of landed cost",
      delivery: "Within 25 working days",
      // justification:
      //   "5 days inspection and sample registration + 12 days testing + 3 days report processing/signing + 1 day dispatch = 21 days.",
    },
    {
      sn: 7,
      service: "Export certification",
      requirements:
        "Conformance assessment specifications for the product from the importing country or buyer; if these are not available, a relevant Malawi standard to be used.",
      // charges: "Admin MK21,000 + test charges + VAT",
      delivery: "Within 25 working days",
      // justification: "Same as import certification timeline.",
    },
    {
      sn: 8,
      service: "Permit certification (local services)",
      requirements:
        "Company registration certificate; Tax Payer Identification Number (TPIN)",
      // charges:
      //   "Inspection MK17,825-46,825 + transport MK103.50/km + test charges + VAT",
      delivery: "Within 25 working days",
      // justification:
      //   "Permit involves both process and product audit; designation uses process audit results only.",
    },
    {
      sn: 9,
      service: "Designation certification (local services)",
      requirements:
        "Company registration certificate; Tax Payer Identification Number (TPIN)",
      // charges:
      //   "Inspection MK17,825-46,825 + transport MK103.50/km + test charges + VAT",
      delivery: "Within 10 working days",
      // justification:
      //   "Permit involves both process and product audit; designation uses process audit results only.",
    },
    {
      sn: 10,
      service: "Consumer Complaints Processing",
      requirements: "Submission of a formal complaint to MBS",
      // charges: "N/A",
      delivery: "Within 21 working days",
      // justification: "N/A",
    },
    {
      sn: 11,
      service: "Testing of food and non-food samples",
      requirements:
        "Service request from the clients indicating the required parameters and quantity of samples",
      // charges: "MK4,000 per parameter + MK5,000 reporting fee (+25% express)",
      delivery:
        "Express Service: Within 7 working days / Normal Service: Within 12 working days",
      // justification:
      //   "Timeline accounts for microbiological analysis, sample receipt, reporting and invoicing.",
    },
    {
      sn: 12,
      service: "Testing of compressive strength in cement samples",
      requirements:
        "Service request from the clients indicating the required parameters and quantity of samples",
      // charges: "MK23,500 per parameter + MK5,000 reporting fee",
      delivery: "Within 30 working days",
      // justification:
      //   "Timeline includes sample receipt, reporting and invoicing processes.",
    },
    {
      sn: 13,
      service: "Repairing and maintenance of electronic equipment",
      requirements:
        "Service request from the clients detailing the fault and the sort of service required",
      // charges: "MK5,500 per man-hour + spare parts + MK5,000 reporting fee",
      delivery: "Within 15 working days",
      // justification:
      //   "Maximum days provided due to variability in fault complexity.",
    },
    {
      sn: 14,
      service:
        "Issuance of a quotation and invoice on verification or calibration request",
      requirements:
        "A filled Service request form with all details complete or provided",
      // charges: "N/A",
      delivery: "Within 3 working days",
      // justification: "N/A",
    },
    {
      sn: 15,
      service: "Calibration of Industrial Equipment",
      requirements: "Client request for service",
      // charges: "MK25,000",
      delivery: "Within 15 working days",
      // justification:
      //   "Includes external processes (approvals, logistics support: fuel, vehicle, driver, DSA).",
    },
    {
      sn: 16,
      service: "Verification/Calibration of Weighbridges",
      requirements:
        "Service request from the clients or expiry of certificate",
      // charges: "MK700,000 + 0.6 x fuel pump price x distance",
      delivery: "Within 20 working days",
      // justification:
      //   "Same external process dependencies as industrial calibration.",
    },
    {
      sn: 17,
      service: "Verification of Weighing Instruments",
      requirements:
        "Service request from the clients or expiry of certificate",
      // charges: "MK1,500-MK30,000",
      delivery: "Within 15 working days",
      // justification: "Same external process dependencies as above.",
    },
    {
      sn: 18,
      service: "Verification/Calibration of Bulk Flow Meters",
      requirements:
        "Service request from the clients or expiry of certificate",
      // charges: "MK180,000",
      delivery: "Within 15 working days",
      // justification: "Same external process dependencies as above.",
    },
    {
      sn: 19,
      service: "Pattern Approval Certificate",
      requirements:
        "Filled Pattern Approval form; submission of test reports, specifications and details of the weighing or measuring instrument; payment by the client",
      // charges: "N/A",
      delivery: "Within 20 working days",
      // justification: "N/A",
    },
    {
      sn: 20,
      service: "Issuance of Work Proposal/Quotations",
      requirements: "Service request from the clients",
      // charges:
      //   "0.5 day: MK51,000/participant; 1 day: MK69,000; 2 days: MK85,500; 4.5 days: MK153,000; tailor-made varies",
      delivery:
        "Within 5 working days from the day of provision of necessary information by the client",
      // justification:
      //   "Quotation preparation follows soliciting job specifications from client.",
    },
    {
      sn: 21,
      service: "IRTACU Services - Issuance of Certificates to client",
      requirements: "Attendance of the training by the participants",
      // charges: "Included in quoted charges",
      delivery:
        "Within 7 working days for non-examinable courses with less than 50 participants / Within 15 working days for examinable courses and non-examinable courses with more than 50 participants",
      // justification:
      //   "Time varies with complexity/TORs; examinable training requires time for marking.",
    },
    {
      sn: 22,
      service: "IRTACU Services - Issuance of Reports to client",
      requirements: "Payment by Client",
      // charges: "Included in quoted charges",
      delivery:
        "30 working days after research or consultancy work and also as per TORs",
      // justification:
      //   "Time varies with complexity/TORs; research and consultancy reports depend on scope.",
    },
  ];

  const internalServices = [
    // {
    //   sn: 1,
    //   service: "Approval of transport requests",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 1 day",
    //   justification: "N/A",
    // },
    // {
    //   sn: 2,
    //   service: "Vehicle Allocation",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 1 day (subject to availability)",
    //   justification:
    //     "Activities may clash, time needed to arrange alternatives",
    // },
    // {
    //   sn: 3,
    //   service: "Processing of payment vouchers",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 3 days",
    //   justification: "Allows for accounting processes",
    // },
    // {
    //   sn: 4,
    //   service: "Office maintenance",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 14 days",
    //   justification: "Allows for approvals & procurement",
    // },
    // {
    //   sn: 5,
    //   service: "Vehicle servicing",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 5 days",
    //   justification: "Service providers have own requirements",
    // },
    // {
    //   sn: 6,
    //   service: "Procurement through Request for Quotation",
    //   requirements: "Approved requisition & IPDC docs",
    //   charges: "N/A",
    //   delivery: "Within 14 days",
    //   justification: "Allows for approvals & procurement",
    // },
    // {
    //   sn: 7,
    //   service: "Procurement through tender",
    //   requirements: "Approved requisition & IPDC docs",
    //   charges: "N/A",
    //   delivery: "Within 90 days",
    //   justification: "Allows for approvals & procurement",
    // },
    // {
    //   sn: 8,
    //   service: "Placement of Advertisements",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 7 days",
    //   justification: "Ensures thorough checking & approvals",
    // },
    // {
    //   sn: 9,
    //   service: "Issuing of Consumables",
    //   requirements: "Appropriate approvals",
    //   charges: "N/A",
    //   delivery: "Within 2 days",
    //   justification: "N/A",
    // },
  ];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#f5f5f5" }}>
      {/* Header */}
      <section
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "120px 20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "rgba(0,0,0,0.55)",
            padding: "40px 30px",
            textAlign: "center",
            color: "white",
            width: "90%",
            maxWidth: "1100px",
            borderRadius: "12px",
            borderLeft: "5px solid #ff6600",
            borderRight: "5px solid #ff6600",
            boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
          }}
        >
          <h1
            style={{ fontSize: "38px", marginBottom: "8px", fontWeight: 700 }}
          >
            Service Charter
          </h1>
          <p style={{ fontSize: "16px", opacity: 0.9 }}>
            Our commitment to Quality, Transparency and Excellence in Service
            Delivery.
          </p>
        </div>
      </section>

      {/* Tables & Commitment */}
      <section
        style={{
          padding: "30px 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "92%",
            maxWidth: "1400px",
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {/* LEFT TABLES */}
          <div
            style={{
              flex: 3,
              minWidth: "650px",
              overflowX: "auto",
            }}
          >
            {/* External Clients Table */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
                marginBottom: "40px",
              }}
            >
              <thead>
                <tr>
                  <th
                    colSpan="6"
                    style={{
                      padding: "8px",
                      textAlign: "center",
                      background: "#fff",
                      color: "#000",
                    }}
                  >
                    MALAWI BUREAU OF STANDARDS (MBS)
                  </th>
                </tr>
                <tr>
                  <th
                    colSpan="6"
                    style={{
                      padding: "6px",
                      textAlign: "center",
                      background: "#fff",
                      color: "grey",
                    }}
                  >
                    COMMITMENT TO COURTESY AND EXCELLENCE IN SERVICE DELIVERY
                  </th>
                </tr>
                {/* <tr>
                  <th
                    colSpan="6"
                    style={{
                      padding: "6px",
                      textAlign: "left",
                      background: "#fff",
                      color: "#ff6600",
                    }}
                  >
                    External Client Services
                  </th>
                </tr> */}
                <tr style={{ background: "#ff6600", color: "#fff" }}>
                  <th style={{ padding: "10px" }}>S/N</th>
                  <th style={{ padding: "10px" }}>SERVICE RENDERED</th>
                  <th style={{ padding: "10px" }}>Requirements</th>
                  {/* <th style={{ padding: "10px" }}>Charges (MK)</th> */}
                  <th style={{ padding: "10px" }}>SERVICE DELIVERY SPECIFICATION</th>
                  {/* <th style={{ padding: "10px" }}>Justification</th> */}
                </tr>
              </thead>
              <tbody>
                {services.map((item) => (
                  <tr
                    key={item.sn}
                    style={{
                      borderBottom: "1px solid #eee",
                      transition: "background 0.2s",
                    }}
                  >
                    <td style={{ padding: "8px" }}>{item.sn}</td>
                    <td style={{ padding: "8px" }}>{item.service}</td>
                    <td style={{ padding: "8px" }}>{item.requirements}</td>
                    {/* <td style={{ padding: "8px" }}>{item.charges}</td> */}
                    <td style={{ padding: "8px" }}>{item.delivery}</td>
                    {/* <td style={{ padding: "8px" }}>{item.justification}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Internal Clients Table */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* <thead>
                <tr>
                  <th
                    colSpan="6"
                    style={{
                      padding: "6px",
                      textAlign: "left",
                      background: "#fff",
                      color: "#ff6600",
                    }}
                  >
                    Internal Client Services
                  </th>
                </tr>
                <tr style={{ background: "#ff6600", color: "#fff" }}>
                  <th style={{ padding: "10px" }}>S/N</th>
                  <th style={{ padding: "10px" }}>Service Rendered</th>
                  <th style={{ padding: "10px" }}>Requirements</th>
                  <th style={{ padding: "10px" }}>Charges (MK)</th>
                  <th style={{ padding: "10px" }}>
                    Service Delivery Specification
                  </th>
                  <th style={{ padding: "10px" }}>Justification</th>
                </tr>
              </thead> */}
              <tbody>
                {internalServices.map((item) => (
                  <tr
                    key={item.sn}
                    style={{
                      borderBottom: "1px solid #eee",
                      transition: "background 0.2s",
                    }}
                  >
                    <td style={{ padding: "8px" }}>{item.sn}</td>
                    <td style={{ padding: "8px" }}>{item.service}</td>
                    <td style={{ padding: "8px" }}>{item.requirements}</td>
                    <td style={{ padding: "8px" }}>{item.charges}</td>
                    <td style={{ padding: "8px" }}>{item.delivery}</td>
                    <td style={{ padding: "8px" }}>{item.justification}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* RIGHT COMMITMENT */}
          <div
            style={{
              flex: 1,
              minWidth: "280px",
              background: "#fff",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 4px 18px rgba(0,0,0,0.1)",
              height: "fit-content",
              borderLeft: "4px solid #ff6600",
              position: "sticky",
              top: "20%",
              alignSelf: "flex-start",
            }}
          >
            <p style={{ fontSize: "14px", lineHeight: "1.6", color: "#333" }}>
              “Commitment to courtesy and excellence in service delivery.”
              <br />
              <br />
              Any service not conforming to these standards, or any officer
              failing to uphold this commitment, should be reported to:
              <br />
              <br />
              <strong>Director General, Malawi Bureau of Standards</strong>
              <br />
              P.O. Box 946, Blantyre, Malawi
              <br />
              📧 <strong>Email:</strong> mbs@mbsmw.org
              <br />
              📞 <strong>Phone:</strong> +265 891 376 444/445/446/447
              <br />
              {/* 📠 <strong>Fax:</strong> +265 1 870 765 */}
              <br />
              <br />
              <strong>It is your right to demand efficient service.</strong>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceCharter;
